/**
 * This fixes a positioning issue for tooltips and popovers that have a placement of "left"
 */

(function($) {
    "use strict";

    var tooltip = $.fn.tooltip.Constructor.prototype,
        popover = $.fn.popover.Constructor.prototype,
        oldApplyPlacement = $.fn.tooltip.Constructor.prototype.applyPlacement,
        newApplyPlacement = function(offset, placement) {
            var $tip = this.tip(),
                pos = this.getPosition();

            oldApplyPlacement.call(this, offset, placement);

            if (placement === 'left') {
                offset.left = pos.left - $tip[0].offsetWidth;
                $tip.offset(offset);
            }
        };

    $.fn.tooltip.Constructor.prototype = $.extend({}, tooltip, {
        applyPlacement: newApplyPlacement
    });

    $.fn.popover.Constructor.prototype = $.extend({}, popover, {
        applyPlacement: newApplyPlacement
    });




}(window.jQuery));
